import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ComponentFactoryResolver, ViewEncapsulation, QueryList, ViewChildren, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IFormOptions, IFieldOptions } from '@framework/interfaces/IEntity';
import { ApiService } from '@services/api/api.service';
import { IEntityModelField } from '@framework/interfaces/IEntityModel';
import { FormBuilderControl } from '@common/formbuilder/FormBuilderControl';
import { FormBuilderControlType } from '@common/formbuilder/FormBuilderControlType';
import { Subscription } from '../../../../../node_modules/rxjs';
import { NbToastrService } from '@nebular/theme';
import { IButtonAction } from '../mf-blade/mf-blade.component';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';
import { ConfirmationService, DynamicDialogConfig, DynamicDialogRef, DialogService } from 'primeng/api';
import { ActionDialogComponent } from '../../../modules/shared/components/action-dialog/action-dialog.component';

export interface IDetailPageComponentTab {
  displayName: string;
  tab: any;
  isHidden?: boolean;
}

@Component({
  selector: 'app-mf-generated-form',
  templateUrl: './mf-generated-form.component.html',
  //styleUrls: ['@framework/components/mf-generated-form/mf-generated-form.component.css']
})
export class MfGeneratedFormComponent implements OnInit, OnDestroy {
  @ViewChild('tabDetail', { static: true }) tabDetail: ViewContainerRef;
  @ViewChildren('tabDetails', { read: ViewContainerRef }) public tabDetails: QueryList<ViewContainerRef>;

  public buttonActions: Array<IButtonAction> = new Array();
  protected detailPageComponentForm: IFormOptions;
  protected detailPageComponentTabs: Array<IDetailPageComponentTab>;
  protected identifierProperty: string;
  protected _canSave: boolean = true;
  public setParentBladeLoading: boolean;
  public isHidden: boolean = false;
  public listIndex: any;
  public formReadonly: boolean;
  private _subscriptions: Array<Subscription> = new Array<Subscription>();
  private _newItem: boolean = false;
  protected _entityId: any;
  private tabInstances: any;
  public formFields: Array<FormBuilderControl>;
  public tabViews: Array<any>;
  public get form(): IFormOptions { return this.detailPageComponentForm };
  public get tabs(): Array<IDetailPageComponentTab> { return this.detailPageComponentTabs };
  public get newItem(): boolean { return this._newItem };
  public entityData: any = {};
  public loading: boolean = false;
  public hidden: boolean = false;
  public newlyAddedItemLoaded: boolean;

  public get entityId() { return this._entityId };
  public set entityId(value) {
    //if (this._entityId == value)
    //  return;

    if (this._entityId == "00000000-0000-0000-0000-000000000000" && this._entityId != value)
      this.newlyAddedItemLoaded = true;


    this._entityId = value;
    this.reset();
    if (value == "00000000-0000-0000-0000-000000000000")
      this.addNew();
    else this.loadEntity();
  }
  public parent: any;
  public get header(): string { return this.entityData && this.form.displayName ? this.entityData[this.form.displayName] : null };
  public activeIndex: number = 0;
  protected loadWithoutParams: boolean = false;

  constructor(public apiService?: ApiService, private route?: ActivatedRoute, private componentFactoryResolver?: ComponentFactoryResolver,
    private messageService?: NbToastrService, public authService?: IdentityAuthService, public confirmationService?: ConfirmationService,
    public ref?: DynamicDialogRef, public dynamicDialogConfig?: DynamicDialogConfig,
    public dialogService?: DialogService) {
  }

  public get canSave() {
    return this._canSave && !this.formReadonly;
  }

  public get canDelete() {
    return !this.newItem && this.form.canDelete && !this.formReadonly;
  }

  private getFormBuilderControls(entityModelFields: Array<IFieldOptions>): Array<FormBuilderControl> {
    return entityModelFields.map(item => {
      let control = new FormBuilderControl();

      let itemDTO: IEntityModelField = this.form.model.fields[item.field];
      control.controlType = new FormBuilderControlType(typeof item.fieldType != 'undefined' ? item.fieldType : itemDTO.fieldType, null);
      control.displayName = item.name ? item.name : itemDTO.displayName;
      control.bindingValue = item.field;
      control.field = item.field;
      control.customControl = item.customControl;
      control.show = function (scope, auth,context) {
        if (item.show) return item.show(scope, auth, context);
        return true;
      };

      if (item.viewType) {
        control.controlType.viewType = item.viewType;
      }
      if (item.lookups) {
        control.lookups = item.lookups;
      }

      control.fieldOptions = item;


      return control;
    });
  }
  private buildTabs() {
    this.tabInstances = new Array();
    for (let i = 0; i < this.tabDetails.toArray().length; i++) {
      let component = this.detailPageComponentTabs[i];
      if (component) {
        let target = this.tabDetails.toArray()[i];
        let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(component.tab);
        let componentRef: any = target.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.entity = component.tab;
        _component.entity.component = _component;
        _component.parent = this;
        this.tabInstances.push(_component);

      }
    }
  }

  public newlyAddedItemLoad() {
    this.newlyAddedItemLoaded = false;
    //Item was created and reloaded
    if (this.parent.componentInstance) {
      if (this.parent.componentInstance.length == 1)//only this one form
        this.parent.closeBlade();
      else this.parent.selectedMenuItemIndex = 1;
    }
  }

  public ngOnInit() {
    
    if (this.loadWithoutParams)
      this.entityId = "0";
    this.formFields = this.getFormBuilderControls(this.detailPageComponentForm.fields);

    if (this.parent && this.parent.entityIdChange) {
      this.entityId = this.parent.entityId;
      this.parent.entityIdChange.subscribe(entityId => {
        this.entityId = entityId;
      })
    }
    else {
      this._subscriptions.push(
        this.route.params.subscribe(params => {
          this.entityId = params['id'];
        })
      );
    }
    if (this.ref) {
      if (this.dynamicDialogConfig && this.dynamicDialogConfig.data) {
        this.parent = this.dynamicDialogConfig.data.parent;
        this.entityId = this.dynamicDialogConfig.data.entityId ? this.dynamicDialogConfig.data.entityId : "00000000-0000-0000-0000-000000000000"
        this._newItem = this.entityId == "00000000-0000-0000-0000-000000000000"
      }
    }
  }

  public ngAfterViewInit() {

    if (this.detailPageComponentTabs && this.detailPageComponentTabs.length > 0) {
      this.buildTabs();
    }

  }

  public ngOnDestroy() {
    while (this._subscriptions.length > 0) this._subscriptions.pop().unsubscribe();
  }

  public loadEntity() {
    var differentEntityId = true;
    let self: MfGeneratedFormComponent = this;
    if (!self.entityId || self.newItem) {
      if (self.form.onLoaded)
        self.form.onLoaded(self, self.entityData);
      //if (self.newItem && self.parent.onNewItemFormLoad)
      //  self.parent.onNewItemFormLoad(self.listIndex, self)
      return;
    }
    if (self.setParentBladeLoading) self.parent.loading = true;
    self.loading = true;
    if (self.form.dataEndPoint)
      self.apiService.exec({
        endPoint: self.form.dataEndPoint,
        context: self,
        success: function (data) {
          if (self.entityData && self.entityData.id == self.entityId)
            differentEntityId = false;
          self.entityData = self._newItem ? {} : data;
          self.loading = false;
          if (self.parent && self.parent.header && self.identifierProperty)
            self.parent.headerIdentifier = self.entityData[self.identifierProperty];

          self.buttonActions = new Array();

          if (self.form.onLoaded)
            self.form.onLoaded(self, self.entityData, differentEntityId);
          self.parent.buildMenus(self.entityData, false, self.listIndex, self)
          if (self.parent.onFormLoad)
            self.parent.onFormLoad(self.entityData, self.listIndex, self)
          if (self.setParentBladeLoading) self.parent.loading = false;

          if (self.newlyAddedItemLoaded)
            self.newlyAddedItemLoad();
        },
        error: function (error) {
          self.loading = false;
          self.messageService.danger('error', 'Could not load');
        }
      })
  }
  public addNew() {
    this._newItem = true;
    this.entityData = {};
    this.parent.selectedMenuItemIndex = 0;
    if (this.form.onLoaded)
      this.form.onLoaded(this, this.entityData);
  }
  public anyControlBlockingSave() {
    var _th = this;
    var valid = true;
    this.formFields.forEach(o => {
      if (o.blockSaving || (o.fieldOptions.validationMessage &&  o.fieldOptions.validationMessage != null && o.fieldOptions.validationMessage !='')) {
        o.requiredAnimation = true;
        valid = false;
      }
      else {
        o.requiredAnimation = false;
      }
    });
    setTimeout(function () {
      _th.formFields.forEach(o => {
        o.requiredAnimation = false;
      })
    }, 1000)
    if (!valid)
      this.messageService.danger('Processing...', 'Please wait for processing to finish before saving');
    return valid;
  }

  public validateFields() {
    var _th = this;
    var valid = true;
    this.formFields.forEach(o => {
      var isRequired = false;
      var anyRequired: any = o.fieldOptions.required;
      if ({}.toString.call(anyRequired) === '[object Function]')  
        isRequired = anyRequired(_th.entityData, _th.authService);
      else isRequired = anyRequired;
      if (isRequired && (!o.fieldOptions.show || (o.fieldOptions.show && o.fieldOptions.show(_th.entityData, _th.authService, _th)))) {
        if (typeof _th.entityData[o.field] == 'undefined' || _th.entityData[o.field] == null || _th.entityData[o.field].toString().replace(/\s/g, '') === '') {
          o.requiredAnimation = true;
          o.validationFailed = true;
          valid = false;
        }
        else {
          o.requiredAnimation = false;
          o.validationFailed = false;
        }
      }
    })
    setTimeout(function () {
      _th.formFields.forEach(o => {
        o.requiredAnimation = false;
      })
    }, 1000)
    return valid;
  }


  public delete() {
    let self: MfGeneratedFormComponent = this;

    self.confirmationService.confirm({
      message: 'Are you sure you would like delete this item?',
      header: 'Delete item',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        self.loading = true;
        if (self.form.endPoints && self.form.endPoints.delete)
          self.apiService.exec({
            endPoint: self.form.endPoints.delete,
            context: self,
            success: function (data) {
              self.loading = false;
              if (self.parent && self.parent.onBladeSave)
                self.parent.onBladeSave(self);
              self.parent.closeBlade();
              self.reset();
              if (self.parent && self.parent.loadData)
                self.parent.loadData();
              if (self.parent && self.parent.selectedItem)
                self.parent.selectedItem = null;

              self.messageService.success('Removed successfully', 'Action');
            }, error: function (error) {
              self.loading = false;
              self.messageService.danger((error && error.error ? error.error : ''), 'Could not remove');
            }
          });
      },
      reject: () => {

      }
    });


  }

  public save(doNotCloseBlade?: boolean) {
    let self: MfGeneratedFormComponent = this;

    if (!this.anyControlBlockingSave())
      return;

    if (!this.validateFields()) {
      const ref = this.dialogService.open(ActionDialogComponent, {
        data: {
          buttonActions: [
            {
              iconClass: "", tooltip: "", text: "Ok", click: function (ref) {
                ref.close();
              }
            }
          ],
          message: `Validations not passed - please review the data before saving again`,
        },
        header: 'Could not save',
        width: '50%'
      });
      //self.messageService.danger('Validations not passed', 'Could not save');
      return;
    }


    if (this.newItem) {
      this.saveNew();
      return;
    }
    self.loading = true;
    if (self.form.endPoints && self.form.endPoints.update)
      self.apiService.exec({
        endPoint: self.form.endPoints.update,
        data: self.entityData,
        context: self,
        success: function (data) {
          self.loading = false;


          if (self.ref && self.dynamicDialogConfig.data)
            self.ref.close(data);
          if (self.parent && self.parent.onBladeSave)
            self.parent.onBladeSave(self);
          if (self.parent && self.parent.closeBlade)
            if (!doNotCloseBlade) {
              self.parent.closeBlade();
              self.reset();
            }
            else self.loadEntity();
          if (self.parent && self.parent.loadData)
            self.parent.loadData();
          if (self.parent && self.parent.selectedItem)
            self.parent.selectedItem = null;


          self.messageService.success('Saved successfully', 'Action');
        }, error: function (error) {
          self.loading = false;
          self.messageService.danger((error && error.error ? error.error : ''), 'Could not save');
        }
      });

  }
  public saveNew() {
    let self: MfGeneratedFormComponent = this;
    self.loading = true;
    if (self.form.endPoints && self.form.endPoints.insert)
      self.apiService.exec({
        endPoint: self.form.endPoints.insert,
        data: self.entityData,
        context: self,
        success: function (item) {
          //close(item);
          self.loading = false;
          self.messageService.success('Created successfully', 'Action');
          if (self.parent && self.parent.navigateToIndex)
            self.parent.navigateToIndex(self.parent.formIndex, item);
          if (self.parent && self.parent.onBladeSave)
            self.parent.onBladeSave(self);
          if (self.ref && self.dynamicDialogConfig.data)
            self.ref.close (item)
          self.reset();
        }, error: function (error) {
          self.loading = false;

          self.messageService.danger((error && error.error ? error.error : ''), 'Could not save. ');
        }
      });
  }

  public reset() {
    this.formReadonly = false;
    this.entityData = {};
    this._newItem = false;
  }

  public cancel() {
    if (this.parent && this.parent.selectedItem)
      this.parent.selectedItem = null;
    if (this.parent && this.parent.closeBlade)
      this.parent.closeBlade();
    if (this.ref)
      this.ref.close();
  }

  public updateLists() {

  }

  public makeFormReadOnly(readonly) {
    this.formReadonly = readonly;
  }
}
